import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { AlertService } from '../alert.service';
import { UserService } from '../services/user.service';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { Facebook } from '@ionic-native/facebook/ngx';
import { Router, NavigationExtras } from '@angular/router';
import { AlertController, Events } from '@ionic/angular';
import { RegularExpressionConstant } from '../utils/regular-expression.constant';
import { NotificationService } from '../notification.service';
declare var amplitude;
@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit {

  signupForm: FormGroup;
  isSubmitted = false;
  isLoggedIn = false;
  isCheckedTerms = false;
  isClickedSignUp = false;
  navigationExtras: any;

  constructor(public formBuilder: FormBuilder,
              public authService: AuthService,
              private alertService: AlertService,
              private userService: UserService,
              private googlePlus: GooglePlus,
              private fb: Facebook,
              private router: Router,
              private events: Events,
              private alertCtrl: AlertController,
              private notificationService: NotificationService
            ) {
    this.signupForm = this.formBuilder.group({
      first_name: ['', [Validators.required, Validators.minLength(2)]],
      last_name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.pattern(RegularExpressionConstant.EMAIL)]],
      password: ['', [Validators.required, Validators.pattern(RegularExpressionConstant.PASSWORD)]],
      terms_and_conditions: [false, Validators.pattern('true')]
    });

    this.navigationExtras = this.router.getCurrentNavigation().extras;
   }

   get errorControl() {
    return this.signupForm.controls;
  }


  ngOnInit() {
  }

//   async checkCookieEnabled(){
//     if(!navigator.cookieEnabled){
//         return false;
//     }
//     const quota = await navigator.storage.estimate()['quota'];
//     return quota > window.performance['memory'].jsHeapSizeLimit;
//   }

  async presentAlert() {
    const alert = await this.alertCtrl.create({
        message: 'We use cookies to ensure that we give you the best experience on our website. Cookies enable us to provide you functionalities such as login via facebook/google and accessibility. They improve usability and performance through various features and thereby improve what we offer to you.',
        buttons: ['OK']
    });
    await alert.present();
  }
  fbLogin() {
    // if(!this.checkCookieEnabled()){
    //     return this.presentAlert();
    // }
      if (this.isCheckedTerms === true) {
          this.fb.login(['public_profile', 'email'])
              .then(res => {
                  if (res.status === 'connected') {
                      this.isLoggedIn = true;
                      // this.getUserDetail(res.authResponse.userID);
                      this.userService.saveUser(res.authResponse.accessToken, 'facebook', {}).toPromise().then((data) => {
                          const parsedResponseData: any = data;
                          if (parsedResponseData.status == true) {
                              this.isLoggedIn = true;
                              localStorage.setItem('pToken', JSON.stringify(parsedResponseData));
                              this.events.publish('user:login', data);
                              amplitude.logEvent("mobile::user_signed_up", {'source': 'facebook', 'userId': data['user']['id']});
                              this.notificationService.subscribeNotifications(data['user']['id']);
                              this.router.navigateByUrl('/home');
                          } else {
                            if (parsedResponseData.status == false && parsedResponseData.error) {
                                    if (parsedResponseData.error.hasOwnProperty('code')) {
                                        this.authService.processExistingSourceError(parsedResponseData);
                                    }
                                    else {
                                        this.alertService.presentToast(parsedResponseData.error.message);
                                    } 
                            }
                            else if (parsedResponseData.error) {
                                this.alertService.presentToast(parsedResponseData.error.message);
                            } else {
                                this.alertService.presentToast('Login Failed');
                            }
                          }
                      });
                  } else {
                      this.isLoggedIn = false;
                  }
              })
              .catch(e => console.log('Error logging into Facebook', e));
      } else {
          this.isClickedSignUp = true;
      }
  }

  googleLogin() {
    // if(!this.checkCookieEnabled()){
    //     return this.presentAlert();
    // }
      if (this.isCheckedTerms === true) {
          this.googlePlus.login({})
              .then(res => {
                  this.userService.saveUser(res.idToken, 'google', {}).toPromise().then((data) => {
                      const parsedResponseData: any = data;
                      if (parsedResponseData.status == true) {
                          this.isLoggedIn = true;
                          this.authService.isLoggedIn = true;
                          localStorage.setItem('pToken', JSON.stringify(parsedResponseData));
                          this.events.publish('user:login', data);
                          amplitude.logEvent("mobile::user_signed_up", {'source': 'google', 'userId': data['user']['id']});
                          this.notificationService.subscribeNotifications(data['user']['id']);
                           if (window.history.state) {
                              const navigationExtras: NavigationExtras = {state: window.history.state};
                              if (navigationExtras.state.redirect) {
                                  this.router.navigateByUrl(navigationExtras.state.redirect, navigationExtras);
                              } else {
                                  this.router.navigateByUrl('/search/promotions');
                              }
                          } else {
                              this.router.navigateByUrl('/search/promotions');
                          }
                          this.alertService.presentToast('Logged in successfully');
                      } else {
                         if (parsedResponseData.status == false && parsedResponseData.error) {
                                if (parsedResponseData.error.hasOwnProperty('code')) {
                                    this.authService.processExistingSourceError(parsedResponseData);
                                }
                                else {
                                    this.alertService.presentToast(parsedResponseData.error.message);
                                } 
                        }
                        else if (parsedResponseData.error) {
                            this.alertService.presentToast(parsedResponseData.error.message);
                        } else {
                            this.alertService.presentToast('Login Failed');
                        }
                      }
                  });
              })
              .catch(err => console.log(err));
      } else {
          this.isClickedSignUp = true;
      }

  }

    onCloseExistingSourceError() {
        this.authService.resetLoginSource();
    }


  submitForm() {
    this.authService.register(this.signupForm.value);
    //     .subscribe(
    //   data => {
    //     this.alertService.presentToast('Registered Successfully');
    //   },
    //   error => {
    //     console.log(error);
    //   }
    // );
  }

  checkedTerms() {
      this.isCheckedTerms = !this.isCheckedTerms;
  }

}
